import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState, useContext } from 'react';
import { isEmpty } from 'underscore';
import { Context } from '../..';
import AskService from '../../services/AskService';
import { QAModal } from './modal/QAModal';

const QA: FC<any> = observer(({ item, setQAModal, setQAID }) => {

    return (
        <div className="col-md-2 m-3 mb-5" style={{ cursor: "pointer" }} onClick={() => {
            setQAModal(true);
            setQAID(item['id']);
        }}>
            <hr />
            <div className="mb-2">
                {!isEmpty(item['answers']) ? <i className='icon check' /> : <i className='icon wait' />}
                <em>
                    {new Date(item['question_date']).toLocaleDateString("ru-RU", {
                        hour: 'numeric',
                        minute: 'numeric',
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                    })}
                </em>
            </div>
            <div className="mb-2">
                <h6>{item['subject'].substring(0, 100) + (item['subject'].length < 100 ? '' : '...')}</h6>
            </div>
        </div>
    )
});

const MyQuestions: FC = () => {
    const { store } = useContext(Context)
    const [qaModal, setQAModal] = useState<boolean>(false);
    const [qaID, setQAID] = useState<any>({});

    const getQA = async () => {
        const qa = await AskService.getQ();
        store.setQA(qa.data.results);
    };

    useEffect(() => {
        getQA();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getItems = () => store.qa.slice().sort((a: any, b: any) => b['id'] - a['id']).map((item: any, i: number) => {
        return <QA key={i} {...{ item, setQAModal, setQAID }} />
    })


    return (
        <div className='row'>
            {getItems()}
            <QAModal toggle={qaModal} setToggle={setQAModal} qaID={qaID} />
        </div>
    )
};
export default observer(MyQuestions);